import { render, staticRenderFns } from "./TooBarDtvGo.vue?vue&type=template&id=39569351"
import script from "./TooBarDtvGo.vue?vue&type=script&lang=js"
export * from "./TooBarDtvGo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports